import type { Language } from '../../i18n/translations.js';

export const DEMO_COPY = {
  en: {
    backLabel: 'Back',
    stepLabel: 'Step',
    playLabel: 'Play',
    pauseLabel: 'Pause',
    loadingLabel: 'Loading video…',
    playComparison: 'Play comparison',
    pauseComparison: 'Pause comparison',
    soundOn: 'Sound on',
    soundOff: 'Sound off',
    dropEmpty: 'Drop the image here',
    dropSelected: 'Nurtelia cookie',
    dropHelpEmpty: 'Prepared image · No upload needed',
    dropHelpSelected: 'The drink will be replaced with this cookie.',
    selectionEmpty: 'Select a product to continue.',
    selectionReady: 'Product selected. Ready to reveal.',
    mediaError: 'Video unavailable. Try playing it again.',
    resultNotice: 'Previously generated result is ready. Play the comparison.',
    viewCountLabel: 'Source video: 1.7 million views, recorded 3 November 2026',
    linkIconLabel: 'Business link',
    joinLabel: 'Join the waitlist',
    tryMouja: 'Try Mouja',
    seeYourProductInTheScene: 'See your product in the scene.',
    preparedExampleNoLiveAnalysisOr:
      'Prepared example. No live analysis or generation.',
    workspace: 'Workspace',
    restartTheDemo: 'Restart the demo',
    restart: 'Restart',
    demoNavigation: 'Demo navigation',
    exampleBusiness: 'Example business',
    previewProgress: 'Preview progress',
    link: 'Link',
    business: 'Business',
    videos: 'Videos',
    product: 'Product',
    result: 'Result',
    skipToResult: 'Skip to result',
    helpMoujaUnderstandYourBusiness: 'Help Mouja understand your business.',
    aWebsiteInstagramOrTiktokLink: 'A website, Instagram or TikTok link.',
    preparedExample: 'Prepared example',
    useThisLink: 'Use this link',
    cookiesWithCharacter: 'Cookies with character.',
    yourBusinessUnderstood: 'Your business, understood.',
    sampleProfile: 'Sample profile',
    business2: 'Business',
    packagedCookies: 'Packaged cookies',
    style: 'Style',
    playfulUnexpected: 'Playful & unexpected',
    videoIdea: 'Video idea',
    anUnexpectedProductReveal: 'An unexpected product reveal',
    chooseAVideo: 'Choose a video',
    chooseAViralVideo: 'Choose a viral video.',
    weLlRemakeItWithYour: 'We’ll remake it with your product.',
    previewTheOriginalDrinkVideo: 'Preview the original drink video',
    label17MViews: '1.7M views',
    theUnexpectedTreat: 'The unexpected treat',
    previewCroissantVideo: 'Preview the original croissant trick',
    croissantViews: '2.7M views · example',
    croissantViewsLabel: 'Illustrative count: 2.7 million views. Not verified.',
    selectedCroissantVideo:
      'The selected video shows a croissant disappearing in a bakery',
    croissantDropHelp: 'The croissant will be replaced with this cookie.',
    aboutCroissantExample:
      'The croissant becomes a Nurtelia cookie, and the bakery sign carries the brand. This is the saved single-pass experiment. Some food details change during the bite; the result has not been retouched to hide them.',
    useThisVideo: 'Use this video',
    aLittleMagicCollectionPreview: 'A little magic, collection preview',
    previewOnly: 'Preview only',
    aLittleMagic: 'A little magic',
    somewhereExtraordinaryTravelCollectionPreview:
      'Somewhere extraordinary, travel collection preview',
    somewhereExtraordinary: 'Somewhere extraordinary',
    addProductImages: 'Add product images.',
    theSelectedVideoShowsAPerson: 'The selected video shows a person carrying a drink',
    yourChosenVideo: 'Your chosen video',
    tapOrDragTheImage: 'Tap or drag the image.',
    preparedProductImages: 'Prepared product images',
    tryThisOne: 'Try this one',
    signatureScent: 'Signature scent',
    previewOnly2: 'Preview only',
    dailyCoffee: 'Daily coffee',
    removeProduct: 'Remove product',
    showTheResult: 'Show the result',
    yourRemadeVideo: 'Your remade video.',
    realResultGeneratedInAdvance: 'Real result. Generated in advance.',
    chooseComparisonView: 'Choose comparison view',
    original: 'Original',
    originalVideoBeforeTheSwap: 'Original video before the swap',
    actualPreviouslyGeneratedProductSwapResult:
      'Actual previously generated product-swap result',
    moujaResult: 'Mouja result',
    videoPosition: 'Video position',
    replayComparison: 'Replay comparison',
    yourChosenProduct: 'Your chosen product',
    changeProduct: 'Change product',
    aboutThisExample: 'About this example',
    theOriginalShowsAPersonCarrying:
      'The original shows a person carrying a drink. In the result, an oversized Nurtelia cookie takes its place. This is a real, humorous experiment; some lettering and motion details are imperfect. The video has not been retouched to hide them.',
    thisExampleDemonstratesPhysicalProductReplacement:
      'This example demonstrates physical-product replacement only. The full journey is not yet automated.',
    projectRoadmap: 'Project roadmap',
    buildingMouja: 'Building Mouja',
    withCpmai: 'with CPMAI.',
    ourProjectFollowsCpmaiWeRevisit:
      'Our project follows CPMAI. We revisit phases as we learn.',
    cpmaiPhasesCoveredSoFar: 'CPMAI phases covered so far',
    covered: 'Covered',
    businessUnderstanding: 'Business Understanding',
    definingTheBusinessObjective: 'Defining the business objective.',
    dataUnderstanding: 'Data Understanding',
    understandingVideosAndCustomerAssets: 'Understanding videos and customer assets.',
    currentPhase: 'Current phase',
    dataPreparation: 'Data Preparation',
    organizingVideosRequiredAssetsAndTested:
      'Organizing videos, required assets and tested editing workflows.',
    theNextStep: 'The next step.',
    withYou: 'With you.',
    weLlEmailYouWhenA: 'We’ll email you when a pilot place is available.',
    confirmationPreview: 'Confirmation preview.',
    thisIsTheConfirmationPreviewNo:
      'This is the confirmation preview; no registration was sent.',
    tryTheFormAgain: 'Try the form again',
    nextStep: 'The next step.',
    pilotContact: 'We’ll email you when a pilot place is available.',
    generationClosed: 'Generation access is not open yet.',
    backToTop: 'Back to top ↑',
  },
  ar: {
    backLabel: 'رجوع',
    stepLabel: 'الخطوة',
    playLabel: 'تشغيل',
    pauseLabel: 'إيقاف',
    loadingLabel: 'جارٍ تحميل الفيديو…',
    playComparison: 'شغّل المقارنة',
    pauseComparison: 'أوقف المقارنة',
    soundOn: 'تشغيل الصوت',
    soundOff: 'كتم الصوت',
    dropEmpty: 'اسحب الصورة هنا',
    dropSelected: 'كوكيز نورتليا',
    dropHelpEmpty: 'صورة جاهزة · لا حاجة للرفع',
    dropHelpSelected: 'سيظهر هذا الكوكيز بدلًا من المشروب.',
    selectionEmpty: 'اختر منتجًا للمتابعة.',
    selectionReady: 'تم اختيار المنتج. النتيجة جاهزة للعرض.',
    mediaError: 'تعذّر تشغيل الفيديو. جرّب تشغيله مرة أخرى.',
    resultNotice: 'النتيجة المولّدة مسبقًا جاهزة. شغّل المقارنة.',
    viewCountLabel: 'الفيديو الأصلي: ١٫٧ مليون مشاهدة، رُصدت في ٣ نوفمبر ٢٠٢٦',
    linkIconLabel: 'رابط النشاط',
    joinLabel: 'انضم لقائمة الانتظار',
    tryMouja: 'جرّب موجة',
    seeYourProductInTheScene: 'شوف منتجك داخل المشهد.',
    preparedExampleNoLiveAnalysisOr: 'مثال جاهز، بدون تحليل أو توليد مباشر.',
    workspace: 'مساحة العمل',
    restartTheDemo: 'إعادة التجربة',
    restart: 'إعادة',
    demoNavigation: 'التنقل في التجربة',
    exampleBusiness: 'نشاط المثال',
    previewProgress: 'مراحل التجربة',
    link: 'الرابط',
    business: 'نشاطك',
    videos: 'الفيديو',
    product: 'المنتج',
    result: 'النتيجة',
    skipToResult: 'شاهد النتيجة',
    helpMoujaUnderstandYourBusiness: 'خلّ موجة تفهم نشاطك.',
    aWebsiteInstagramOrTiktokLink: 'رابط موقع، إنستغرام أو تيك توك.',
    preparedExample: 'مُعدّ للمثال',
    useThisLink: 'استخدم هذا الرابط',
    cookiesWithCharacter: 'كوكيز بطابع مرح.',
    yourBusinessUnderstood: 'هكذا نفهم نشاطك.',
    sampleProfile: 'ملف تجريبي',
    business2: 'النشاط',
    packagedCookies: 'كوكيز مغلّف',
    style: 'الطابع',
    playfulUnexpected: 'مرح وغير متوقّع',
    videoIdea: 'فكرة الفيديو',
    anUnexpectedProductReveal: 'ظهور مفاجئ للمنتج',
    chooseAVideo: 'اختر فيديو',
    chooseAViralVideo: 'اختر فيديو منتشر.',
    weLlRemakeItWithYour: 'نعيد صنعه بمنتجك داخل المشهد.',
    previewTheOriginalDrinkVideo: 'معاينة فيديو المشروب الأصلي',
    label17MViews: '١٫٧ مليون مشاهدة',
    theUnexpectedTreat: 'مفاجأة الكوكيز',
    previewCroissantVideo: 'معاينة خدعة الكرواسون الأصلية',
    croissantViews: '٢٫٧ مليون مشاهدة · مثال',
    croissantViewsLabel: 'عدد توضيحي: ٢٫٧ مليون مشاهدة. غير موثّق.',
    selectedCroissantVideo: 'الفيديو المختار: خدعة إخفاء كرواسون داخل مخبز',
    croissantDropHelp: 'سيظهر هذا الكوكيز بدلًا من الكرواسون.',
    aboutCroissantExample:
      'يتحوّل الكرواسون إلى كوكيز نورتليا، وتظهر العلامة على لوحة المخبز. هذه نتيجة محفوظة من تجربة توليد واحدة. تتغيّر بعض تفاصيل المنتج أثناء القضم؛ لم نعدّل النتيجة لإخفائها.',
    useThisVideo: 'استخدم هذا الفيديو',
    aLittleMagicCollectionPreview: 'لمسة من السحر، معاينة من المجموعة',
    previewOnly: 'للمعاينة فقط',
    aLittleMagic: 'لمسة من السحر',
    somewhereExtraordinaryTravelCollectionPreview:
      'مكان خارج المألوف، معاينة من مجموعة السفر',
    somewhereExtraordinary: 'مكان خارج المألوف',
    addProductImages: 'أضف صور منتجك.',
    theSelectedVideoShowsAPerson: 'الفيديو المختار: شخص يحمل مشروبًا',
    yourChosenVideo: 'الفيديو الذي اخترته',
    tapOrDragTheImage: 'اضغط على الصورة أو اسحبها.',
    preparedProductImages: 'صور المنتجات الجاهزة',
    tryThisOne: 'متاح للتجربة',
    signatureScent: 'عطر',
    previewOnly2: 'للعرض فقط',
    dailyCoffee: 'قهوة',
    removeProduct: 'إزالة المنتج',
    showTheResult: 'شاهد النتيجة',
    yourRemadeVideo: 'فيديوك بعد التعديل.',
    realResultGeneratedInAdvance: 'نتيجة فعلية، مولّدة مسبقًا.',
    chooseComparisonView: 'اختر عرض المقارنة',
    original: 'الفيديو الأصلي',
    originalVideoBeforeTheSwap: 'الفيديو الأصلي قبل الاستبدال',
    actualPreviouslyGeneratedProductSwapResult:
      'النتيجة الفعلية لاستبدال المنتج، مولّدة مسبقًا',
    moujaResult: 'نتيجة موجة',
    videoPosition: 'موضع تشغيل الفيديو',
    replayComparison: 'إعادة المقارنة من البداية',
    yourChosenProduct: 'المنتج الذي اخترته',
    changeProduct: 'غيّر المنتج',
    aboutThisExample: 'عن هذا المثال',
    theOriginalShowsAPersonCarrying:
      'في الأصل، يحمل الشخص مشروبًا. في النتيجة، يظهر كوكيز نورتليا كبير الحجم في مكانه. النتيجة من تجربة حقيقية بطابع مرح؛ بعض تفاصيل الكتابة والحركة غير مثالية. لم نعدّل الفيديو لإخفاء هذه التفاصيل.',
    thisExampleDemonstratesPhysicalProductReplacement:
      'هذا المثال يوضح استبدال منتج مادي فقط، والرحلة الكاملة لم تصبح تلقائية بعد.',
    projectRoadmap: 'رحلة المشروع',
    buildingMouja: 'نبني موجة',
    withCpmai: 'بمنهجية CPMAI.',
    ourProjectFollowsCpmaiWeRevisit:
      'ندير المشروع بمنهجية CPMAI، ونراجع المراحل مع كل تعلّم.',
    cpmaiPhasesCoveredSoFar: 'مراحل CPMAI التي عملنا عليها حتى الآن',
    covered: 'تم العمل عليها',
    businessUnderstanding: 'فهم الأعمال',
    definingTheBusinessObjective: 'تحديد هدف المشروع.',
    dataUnderstanding: 'فهم البيانات',
    understandingVideosAndCustomerAssets: 'فهم الفيديوهات ومواد العميل.',
    currentPhase: 'مرحلتنا الحالية',
    dataPreparation: 'تجهيز البيانات',
    organizingVideosRequiredAssetsAndTested:
      'نرتّب الفيديوهات، ونحدّد المواد المطلوبة، ونجهّز خطوات التعديل المجرّبة.',
    theNextStep: 'الخطوة الجاية،',
    withYou: 'معك.',
    weLlEmailYouWhenA: 'بنراسلك عند توفّر مكان في التجربة الأولية.',
    confirmationPreview: 'معاينة التأكيد.',
    thisIsTheConfirmationPreviewNo: 'هذا عرض لرسالة التأكيد فقط؛ لم يُرسل أي تسجيل.',
    tryTheFormAgain: 'جرّب النموذج مرة أخرى',
    nextStep: 'الخطوة الجاية،',
    pilotContact: 'بنراسلك عند توفّر مكان في التجربة الأولية.',
    generationClosed: 'توليد الفيديوهات غير متاح بعد.',
    backToTop: 'العودة للأعلى ↑',
  },
} satisfies Record<Language, Record<string, string>>;
